/* eslint-disable quote-props */
export const backgroundCover = {
  'background-size': 'cover'
};
export const backgroundContain = {
  'background-size': 'contain'
};


export const wrapperStyles = {
  ...backgroundCover,
  'display': 'block',
  'position': 'relative',
};

export const tilesWrapperStyles = {
  ...backgroundCover,
  'display': 'flex',
  'position': 'relative',
  'width' : '100%'
};

export const tilesWrapperMobileStyles = {
  ...backgroundCover,
  'display': 'flex',
  'position': 'relative',
  'width' : '100%',
  'justify-content':'center',
  'flex-direction' : 'column'
};

export const containerStyles = {
  ...backgroundCover,
  'display' : 'block',
  'position': 'relative',
};

export const columnsWrapperStyles = {
  'display': 'inline-block',
  'position': 'relative',
  'width': '100%'
};

export const singleColumnStyles = {
  'display': 'inline-block',
  'position': 'relative',
  'width' : '50%',
  'float' : 'left'
};

export const singleColumnTabletStyles = {
  'display': 'block',
  'width' : '100%'
};

export const galleryImagesStyles = {
  ...backgroundCover,
  'display': 'block',
  'background-position-x' : '50%',
  'background-position-y' : '50%'
};

export const logoStyles = {
  ...backgroundContain
};

export const centerAlignStyles = {
  'display' : 'block',
  'position': 'relative',
  'margin-right': 'auto',
  'margin-left': 'auto',
  'text-align': 'center'
};

export const buttonsCenterWrapper = {
  'display' : 'block',
  'position': 'relative',
  width: 'fit-content',
  'margin-left': 'auto',
  'margin-right': 'auto',
  'flex-wrap': 'wrap'
};

export const singleButtonWrapperStyles = {
  'text-align' : 'center',
  'cursor': 'pointer'

};

export const imageStyles = {
  ...backgroundContain
};

export default [
  wrapperStyles,
  containerStyles,
  columnsWrapperStyles,
  singleColumnStyles,
  singleColumnTabletStyles,
  tilesWrapperStyles,
  imageStyles,
  logoStyles,
  centerAlignStyles,
  buttonsCenterWrapper,
  singleButtonWrapperStyles,
  backgroundCover,
  backgroundContain
];
